import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class EmployerSortField extends BaseModel {
  static override constructorName = 'EmployerSortField'

  id: string = ''
  name: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
      this.id = String(this.id ?? '')
    }
  }
}

registerModel(EmployerSortField)
